import React from "react";
import { ReactComponent as Logo } from "../../svgs/logo-grey.svg";
import "./spinner.css";

const Spinner = ({
  loading,
  image,
}: {
  loading: boolean;
  image?: React.ReactNode;
}) => {
  if (!loading) return null;

  return (
    <div id="center" className="spinner">
      <div className="sweet-loading">
        {image ? (
          image
        ) : (
          <Logo height="100" width="75" className="spinner-loading" />
        )}
      </div>
    </div>
  );
};

export default Spinner;
